import { FileInputs } from './file-input'
import controller from './controller'
import hoverLabel from './hover-label'
import { Selects } from './selects'
import { SubmitChange } from './submit-change'

export { FileInputs, controller, hoverLabel, Selects, SubmitChange }
